export default __webpack_public_path__ + "e8a4f21cc7ed7e6cacddd29412007fd7.otf";